import type { ReactNode } from 'react';

export interface PublishGridProps {
  children: ReactNode;
  sidePanel: ReactNode;
}

/**
 * 60/40 grid used by `PublishOrderPage`. Left column scrolls the form
 * sections, right column hosts a sticky map + live summary panel. On
 * mobile both columns stack and the side panel drops below the form.
 *
 * Sized to fill its parent height so the wrapping layout controls the
 * available space.
 */
export function PublishGrid({ children, sidePanel }: PublishGridProps) {
  return (
    <div className="flex flex-col md:flex-row items-start gap-4 h-full">
      <div className="w-full md:w-[60%] md:h-full overflow-y-auto md:pe-1">{children}</div>
      <div className="w-full md:w-[40%] md:h-full overflow-y-auto md:sticky md:top-0">
        {sidePanel}
      </div>
    </div>
  );
}
